export default function Controls({
  onRevealTitle,
  onRevealArtist,
  onRevealYear,
  onRevealAll,
  onNext,
  revealed,
  canReveal,
  hasNextSong,
  canNext,
}) {
  const allRevealed = revealed.title && revealed.artist && revealed.year;
  return (
    <div className="controls">
      <button
        className={`reveal-button ${revealed.title ? 'revealed' : ''}`}
        onClick={onRevealTitle}
        disabled={revealed.title || !canReveal}
      >
        {revealed.title ? 'Revealed Title' : 'Reveal Title'}
      </button>

      <button
        className={`reveal-button ${revealed.artist ? 'revealed' : ''}`}
        onClick={onRevealArtist}
        disabled={revealed.artist || !canReveal}
      >
        {revealed.artist ? 'Revealed Artist' : 'Reveal Artist'}
      </button>

      <button
        className={`reveal-button ${revealed.year ? 'revealed' : ''}`}
        onClick={onRevealYear}
        disabled={revealed.year || !canReveal}
      >
        {revealed.year ? 'Revealed Year' : 'Reveal Year'}
      </button>

      <button
        className={`reveal-button ${allRevealed ? 'revealed' : ''}`}
        onClick={onRevealAll}
        disabled={allRevealed || !canReveal}
      >
        {allRevealed ? 'Revealed All' : 'Reveal All'}
      </button>

      <button
        className="next-button"
        onClick={onNext}
        disabled={!hasNextSong || !canNext}
      >
        Next Song
      </button>
    </div>
  );
}
